module.exports = __webpack_public_path__ + "img/score1.57bef590.png";